import classnames from "classnames";
import { inject } from "mobx-react";
import React from "react";
import { Store } from "../../../../client/stores";
import type { MicrositeGeneralConfigFragment, MicrositeSocialConfigFragment } from "../../generated/webapi.g";
import { formatImage } from "../../lib/image-asset";
import { socialConfigAbstract } from "../../lib/social";
import { SocialIcons } from "../icons/SocialIcons.component";
import { LiveCard, LiveCardImage, LiveCardType } from "../livecard/LiveCard.component";
import "./MicrositeHeader.style.scss";
import type { MicrositeType } from "./MicrositeTypes";

interface MicrositeHeaderProps {
    general?: MicrositeGeneralConfigFragment | null;
    social?: MicrositeSocialConfigFragment | null;
    type: MicrositeType;
    store?: Store;
    view_name?: string;
    slug?: string;
}

export const MicrositeHeader = inject("store")((props: MicrositeHeaderProps) => {
    const headerClass = classnames("microsite-header", {
        [`type-${props.type}`]: props.type,
    });
    const network = props.social ? socialConfigAbstract(props.social) : [];
    const content = network.length > 0 ? <SocialIcons networks={network} /> : null;
    const title = props.general?.name || "";
    const url = props.slug ? `/featured/${props.slug}` : undefined;
    const image = props.general?.thumbnail_image?.id || "";
    const cardImage: LiveCardImage = {
        url: props.store?.env ? formatImage(image, props.store.env) : image,
        source: "station",
    };

    return (
        <LiveCard
            className={headerClass}
            content={content}
            image={cardImage}
            title={title}
            type={LiveCardType.MICROSITE}
            url={url}
            h1={props.view_name !== "detail"}
            target="_self"
        />
    );
});

export default MicrositeHeader;
